import { Component } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { NgForOf, NgIf } from '@angular/common';

@Component({
  selector: 'app-repeat-type',
  imports: [FormlyModule, NgIf, NgForOf],
  templateUrl: './repeat-type.component.html',
  styleUrl: './repeat-type.component.scss',
})
export class RepeatTypeComponent extends FieldArrayType {}
